import {NgModule} from "@angular/core";

import {LanguageSelectorComponent} from "./language-selector/language-selector.component";
import {I18nPipe} from "./i18n.pipe";
import {CommonModule} from "@angular/common";
import {BsDropdownModule} from "ngx-bootstrap";
import { CommonService } from "@app/shared/common/common.service";

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule,
  ],
  declarations:[
    LanguageSelectorComponent,
    I18nPipe
  ],
  exports: [LanguageSelectorComponent, I18nPipe],
  providers: [CommonService]

})
export class I18nModule{}
